module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/2000-12-25/2000-12-25_vis-9ccb2fe016bc48c05894513b8b0d06a4.jpg";